import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import partner from "./slices/partnerSlice";
import admin from "./slices/adminSlice";
import profile from "./slices/profileSlice";
import blogs from "./slices/blogSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    partner,
    admin,
    profile,
    blogs,

    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
